export default "__VITE_ASSET__CFT6MtE8__"